import { CARD_SURFACE } from '@/components/ui/section-card-variants'
import { cn } from '@/lib/utils'

/**
 * The dictionary list's boxes, shared by `DictionaryTermRow` and
 * `DictionaryListSkeleton` so the pending page is the loaded list's shape at
 * every width. A `.ts` sibling so both component files export only a
 * component.
 *
 * A row is a term line (`text-h-s`, 20px) over a truncated one-line
 * definition (`text-body-xs`, 16px), `py-3` around the pair — comfortably past
 * the 44px touch minimum on its own.
 */
export const DICTIONARY_LIST = cn(CARD_SURFACE, 'overflow-hidden')

export const DICTIONARY_ROW = 'border-b border-border-subtle last:border-b-0'

export const DICTIONARY_ROW_LINK =
  'flex flex-col gap-1 px-5 py-3 transition-colors hover:bg-popover focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-ring'
